import React from 'react';

const ComprobanteEnvio = ({data, fechaEnvio, refValue}) => {
  return (
    <div className='d-none'>
      <div className="card m-3" ref={refValue}>
        <div className="card-body">
          <div className="card-text">
            <h5 className='text-uppercase'>Comprobante de envío de notificación digital</h5>
            <h5>{data.asunto || ''}</h5>
            <div><b>Tipo:</b> {data.tipo || ''}</div>
            <div><b>Obligado:</b> {(data.usuario_notificado && data.usuario_notificado.value) || ''}</div>
            <div><b>Notificador:</b> {(data.usuario_notificado && data.usuario_notificador.value) || ''}</div>
            <div><b>Fecha de envío:</b> {`${fechaEnvio || data.fecha_actualizacion}` || ''}</div>
          </div>
          <footer className="blockquote-footer mt-3">Tribunal de Cuentas de Neuquén - {data.fecha_servidor || ''}</footer>
        </div>
      </div>
    </div>
  );
};

export default ComprobanteEnvio;